import { displayAcknowledgeDate, getTrendClass } from "../../helpers/renderHelper";
import { User } from "../../models/User";
import { Row, Col } from "react-bootstrap";


const DriverCard = ({user, onClick, isSummary = false, isFirst = false, isLast = false, carouselMode = false, navigateLeft, navigateRight}:
	{user:User|undefined, onClick?:(any)=>void, isSummary?:boolean, isFirst?:boolean, isLast?:boolean, carouselMode?:boolean, navigateLeft?:(any)=>void, navigateRight?:(any)=>void}) => {

	const score = user?.scorecard
	const trendClass = getTrendClass(score?.trend, "fs-7")

	var background = "bg-primary"
	var iconClass = "bi-exclamation-octagon-fill"
	var color = "white"
	if (score && score.currentScore) {
		if (score.currentScore <= 60) {
			background = "bg-danger"
		} else if (score?.currentScore < 90) {
			background = "bg-warning"  
			color = "black"
			iconClass = "bi-exclamation-triangle-fill"
		} else if(score?.currentScore >= 90){
			background = "bg-success" 
			iconClass = "bi-hand-thumbs-up-fill"
		}
	}

	if (user === undefined) {
		return <div />
	}

	const showLeftArrow = !isFirst
	const showRightArrow = (isSummary || !isLast)

	const auxillaryStyle = {alignSelf:'center', marginLeft:'auto', marginRight:'auto'}
	const iconStyle = { width:`${carouselMode ? '65px' : '55px'}`, marginLeft: `${carouselMode ? '0px' : '15px'}` ,color: color, marginRight: "0.65rem",alignSelf:'center',display:'flex', justifyContent:'center', borderRadius: "0.25rem"}
	const arrowStyle = {alignSelf:'center', display:'flex', justifyContent:'center', alignItems:'center'}

	return (
		<div className="card tile w-100" onClick={ onClick }>
			<Row className="g-0 align-items-center">
				{ carouselMode && (
					<Col xs="auto">
						<div onClick={showLeftArrow ? navigateLeft : () => {}} style={{ width:"40px", display:'flex'}} data-testid="left-arrow-container">
							<i className={showLeftArrow ? "fa-solid fa-chevron-left fs-7 mt-0" : ""} style={auxillaryStyle}></i>
						</div>
					</Col>
				)}
				<Col xs="auto">
					<div className={`${background}`} style={iconStyle}> <i className={`bi ${iconClass} fa-2x`}></i> </div>
				</Col>
				<Col>
					<div className="app-page-text app-driver-card-text">
						<div className="fs-5 mb-sm-0 fw-bold" style={{overflow:"hidden", whiteSpace:'nowrap', textOverflow:'ellipsis'}} >{`${user?.firstName} ${user?.lastName}`}</div>
						<div className="fs-6 mt-sm-0 fw-bold" style={{marginTop:-5}}>{`Score: ${score?.currentScore ?? '-  '} `}<i className={trendClass}></i></div>
						<div className="fs-8 fst-italic mt-sm-0 fw-bold" style={{marginBottom:5}} ><i className="fa-solid fa-square-check icn-orange" />&nbsp;&nbsp;{score?.acknowledgment ? displayAcknowledgeDate(score?.acknowledgment?.acknowledgedDate) ?? "Not Acknowledged" : "Not Required"}</div>
					</div>
				</Col>
				<Col xs="auto">
					<div onClick={showRightArrow ? navigateRight : () => {}} style={{ width:50, height:50, ...arrowStyle}} data-testid="right-arrow-container">
						<i className={showRightArrow ? "fa-solid fa-chevron-right fs-7 mt-0" : ""}></i>
					</div>
				</Col>
			</Row>
		</div>
	)	
	
}

export default DriverCard;